/** Shared PlanPage layout helpers (lint split). */
export function resolveGridView(isOverGrid, activeView) {
  if (!isOverGrid) return null;
  if (activeView === 1) return 'week';
  if (activeView === 2) return 'month';
  return 'day';
}

export function buildPlanTabs(t, isBattlefield) {
  if (isBattlefield) return [{ label: t('plan.day', 'Day') }];
  return [
    { label: t('plan.day', 'Day') },
    { label: t('plan.week', 'Week') },
    { label: t('plan.month', 'Month') },
  ];
}

export function buildRailSelectionHandlers(setFocusOwnerId, setSelectedTaskIds) {
  return {
    overdue: (ids) => {
      setFocusOwnerId('overdue');
      setSelectedTaskIds(ids);
    },
    'next-action': (ids) => {
      setFocusOwnerId('next-action');
      setSelectedTaskIds(ids);
    },
    unscheduled: (ids) => {
      setFocusOwnerId('unscheduled');
      setSelectedTaskIds(ids);
    },
  };
}
